import React from 'react';
import { apiGet, getHostApi, isOnPath } from '../../store/apiWrapper';
import { getLanguage } from '../../store/storeFunctions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { entityIdentRowActions } from '../../store/entityIdentRowStore';
import { Formik, Form } from 'formik';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { layoutActions } from '../../store/layoutStore';
import { searchActions, searchType } from '../../store/searchStore';
import { windowActions } from '../../store/windowStore';
import { withLocalize, Translate } from 'react-localize-redux';
import { withRouter } from 'react-router';
import * as Yup from '../common/Yup';
import AngleDownIcon from '../../img/icons/BBiconsRozbalit';
import BbCollapse from '../common/BbCollapse';
import BbInput from '../styling/bbInput';
import classnames from 'classnames';
import moment from 'moment';
import SearchIcon from '../../img/icons/Search';
import SearchTip from '../common/searchTip';
import SanitizedLink from '../common/sanitizedLink';

// Related components
import QuickSearchResults from './quickSearchResults';
import CalendarIcon from '../../img/icons/Kalendar';

// Stylesheets
import "../../css/search/search.scss";
import "../../css/common/colors.css";
import { domainActions } from '../../store/domainStore';
import { lastSubjectActions } from '../../store/lastSubjectsStore';

class SearchComponent extends React.Component {
    searchInputRef = undefined;
    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
    }

    opKetCodes = {
        9: function () { return false; }, /*TAB*/
        13: function () { return false; },
        16: function () { return false; }, /*SHIFT*/
        17: function () { return false; }, /*CTRL*/
        18: function () { return false; }, /*ALT*/
        27: function () { return false; }, /*ESC*/
        32: function () { return false; }, /*SPACE*/
        37: function () { return false; }, /*?*/
        38: function () { return false; }, /*?*/
        39: function () { return false; }, /*?*/
        40: function () { return true; }/*?*/
    }

    state = {
        dob: undefined,
        isPo: undefined,
        query: undefined,
        stamp: 0,
        isSearching: false,
        validLength: false,
        subjectsLoading: false,
        subjectsError: null,
        lastSearchedSubjects: [],
        qsResult: null,
        reset: false
    };

    componentDidUpdate(prevProps, prevState) {
        if (this.props.focusInput) {
            this.searchInputRef.focus();
            this.props.focusedQuickSearch();
        }
        if (isOnPath({ regex: /^\/search$/i }) && this.props.layout.topMenuExpanded) {
            this.props.expandTopMenu();
        }
        if (this.state.dob !== prevState.dob && this.props.isPo === prevProps.isPo) {
            this.onInputChanged(null, true);
        }
    }

    componentDidMount() {
        !this.props.ls.isLoading && !this.props.ls.dataLoaded && !this.props.ls.error && this.props.getSubjects();
        const sp = this.props.searchParams || {};
        if (!isNullOrUndefined(this.props.history.location.state) && !isNullOrUndefined(this.props.history.location.state.reset))
            this.setState({ reset: this.props.history.location.state.reset, isSearching: false, qsResult: undefined });
        else {
            this.setState({ query: sp.name, isSearching: false, qsResult: undefined });
            this.searchInputRef.value = sp.name || '';
        }
    }

    render() {
        return (
            <div className="search-wrap">
                <div className='search-content'>
                    <div>
                        <SearchTip windowId={`tips_search_${this.props.isPo ? "company" : "physical_person"}`} getSearchTipsModel={this.getSearchTipsModel} />
                        <div className="search-container">
                            <Formik enableReinitialize
                                onSubmit={(values) => this.submitNew(values)}
                                initialValues={this.createInitialValues()}
                                validationSchema={this.createValidationSchema()}
                            >
                                {({ errors, touched, values }) => this.renderSearch(values, errors, touched)}
                            </Formik>
                        </div>
                    </div>
                    {this.renderLinks()}
                </div>
            </div>
        );
    }

    renderSearch = (values, errors, touched) => {
        const searchEnabled = (!isNullOrUndefined(this.state.query) && this.state.query.length >= 3) ||
            (!isNullOrUndefined(this.state.lastValidDob) && this.state.validDob) ||
            (values.isPo && (values.bankAccount.length >= 3 || values.street.length >= 3 || values.rdc.length >= 1));

        return (
            <>
                <div className="quick-search-container">
                    <div className="switch">
                        <div className="btn-wrap">
                            <div className="po-button" style={{ fontWeight: this.props.isPo ? "600" : "400" }}
                                onClick={() => this.triggerChangeEntityType(true)}>{this.props.translate("Search.Common.Company")}</div>
                            {this.props.isPo && <div className="search-progress-short" />}
                        </div>
                        <div className="btn-wrap">
                            <div className="po-button" style={{ fontWeight: !this.props.isPo ? "600" : "400" }}
                                onClick={() => this.triggerChangeEntityType(false)}>{this.props.translate("Search.Common.PhysicalPerson")}</div>
                            {!this.props.isPo && <div className="search-progress-short" />}
                        </div>
                    </div>
                    <div className="search-box" >
                        {this.props.isPo && this.renderPoQuickSearch()}
                        {!this.props.isPo && this.renderFoQuickSearch()}
                    </div>
                </div>
                <div className="basic-search-form" style={{ width: '100%' }}>
                    <BbCollapse isOpen={this.props.basicFormExpanded}>
                        {this.renderExtendedSearch(errors, touched)}
                    </BbCollapse>
                </div>
                <div style={{ textAlign: 'center' }}>
                    <div className={`basic-search-link${isNullOrUndefined(this.state.qsResult) ? "" : " search-done"}`}
                        onClick={() => this.props.toggleBasicForm(!this.props.basicFormExpanded)} style={{ position: 'relative', top: '2px' }}>
                        <div className="basic-search-link-label">
                            <Translate id={this.props.basicFormExpanded ? 'Search.BasicSearch.SectionName' : 'Search.Advanced.Search'} />&nbsp;
                            <AngleDownIcon icon='angle-down' className='svg-standard-fill'
                                style={{ transform: `scaleY(${this.props.basicFormExpanded ? -1 : 1})` }} />
                        </div>
                    </div>
                </div>
                <div className="columns m-0">
                    <div className="column" style={{
                        textAlign: "center", padding: "1em", marginBottom: "1em", display: "flex", flexBasis: "auto",
                        flexWrap: "wrap", justifyContent: "center"
                    }}
                    >
                        <button onClick={() => document.querySelector("#fake-submit").click()} style={{ fontWeight: 600 }} disabled={!searchEnabled}
                            className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                        >
                            <Translate id="Search.Common.Search" /></button>
                    </div>
                </div>
            </>
        )
    }

    triggerChangeEntityType = (val) => {
        if (val !== this.props.isPo)
            this.props.closeAll();
        this.setState({ isSearching: false, qsResult: undefined, query: '', dob: '', validDob: false, lastValidDob: '' });
        this.props.triggerChangeEntityType(val);
    }

    renderFoQuickSearch = () => {
        return (
            <div className="search-inputs">
                <div className="control-row">
                    <div className="control search-name">
                        <div style={{ display: "flex", alignItems: 'center', width: '100%' }}>
                            <span className='with-pointer'>
                                <SearchIcon fill='#969da1' className="search-icon-svg" viewBox='30 30 150 150' />
                            </span>
                            <input onFocus={() => this.onFocus()} ref={(el) => this.searchInputRef = el} autoComplete='off' style={{ paddingLeft: '.25em' }}
                                placeholder={this.props.translate("Search.Placeholder.Fo")} type="text" className='ellipsis search-input'
                                onKeyUp={this.onInputChanged} onKeyDown={this.onSearchSubmit} />
                        </div>
                        <div className={classnames('search-progress', { 'searching': this.state.isSearching || (this.props.ls.isLoading && this.props.quickSearchResults.mainSearch) })} />
                        {this.renderQsResult({ extraData: 'desktop|mobile', basicLink: 'desktop', buttons: 'desktop' }, true, 2)}
                    </div>
                    <div className='control search-dob' ref={(el) => this.searchDobRef = el}>
                        <div className={classnames("day-picker-ultimate", { 'babylon-success': this.state.validDob })} style={{ borderBottom: '1px solid #dbdbdb', display: 'flex' }}>
                            <CalendarIcon className='calendar' fill="currentColor" />
                            <input type="text" className='ellipsis search-input' onKeyUp={this.onDateChange}
                                onKeyDown={this.onSearchSubmit} autoComplete='off' ref={(el) => this.dobInputRef = el}
                                placeholder={this.props.translate("Search.Placeholder.Dob")}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderPoQuickSearch = () => {
        return (
            <div className="search-inputs">
                <div className="control">
                    <div style={{ display: "flex", alignItems: 'center' }}>
                        <span className='with-pointer'>
                            <SearchIcon fill='#969da1' className="search-icon-svg" viewBox='30 30 150 150' />
                        </span>
                        <input onFocus={() => this.onFocus()} ref={(el) => this.searchInputRef = el} autoComplete='off'
                            placeholder={this.props.translate("Search.Placeholder")} type="text"
                            className={`ellipsis search-input${this.state.selectedResult !== null ? " real-entity-id" : ""}`}
                            onKeyUp={this.onInputChanged} onKeyDown={this.onSearchSubmit} />
                    </div>
                    {this.renderQsResult({ extraData: 'desktop|mobile', basicLink: 'desktop', buttons: 'desktop' }, false, 1)}
                </div>
                <div className={classnames('search-progress', { 'searching': this.state.isSearching || (this.props.ls.isLoading && this.props.quickSearchResults.mainSearch) })} />
            </div>
        );
    }

    renderQsResult = (mode, condensed, filterType) => {
        if (!this.props.quickSearchResults.mainSearch)
            return null;

        return (<QuickSearchResults subId='mainSearch'
            searchInputRef={[this.searchInputRef, this.searchDobRef]}
            sr={this.state.qsResult} mode={mode} condensed={condensed} condenseOnlyDoB={true}
            ls={!this.props.user.authentication.limitedUser ? this.props.ls.lastSearchedSubjects : []}
            query={this.state.query} lsFilterType={filterType}
            subjectsLoading={this.props.ls.isLoading}
            hideLastSubjectsOnMobile={true}
        />
        );
    }

    onDateChange = (event) => {
        const dob = (event.target.value || '').replace(/\s/g, '').replace(/[/\\]/g, '');
        const validDate = moment(dob, 'DD.MM.YYYY', true).isValid() || moment(dob, 'D.M.YYYY', true).isValid();
        const isId = !validDate && dob.length > 8 && dob.split('').filter(x => x >= '0' && x <= '9').length === dob.length;
        const isYear = !validDate && dob.length === 4 && dob.split('').filter(x => x >= '0' && x <= '9').length === dob.length;
        const lastValidDob = validDate || isId || dob === '' || isYear ? dob : this.state.lastValidDob;
        this.setState({ dob, validDob: validDate || isId, lastValidDob });
    }

    renderExtendedSearch = (errors, touched) => {
        const flexStyle = this.props.isPo ? { flex: '0 1 31%' } : { flex: '0 1 49%' }
        return (<Form id="search-form">
            <div className='columns is-multiline is-centered m-0'>
                {this.props.isPo && <BbInput style={flexStyle} label={this.props.translate("Report.Account")} name="bankAccount" type="text" errors={errors} touched={touched} />}
                {this.props.basicFormWasExpanded && <BbInput style={flexStyle} label={this.props.translate('Search.Label.RegionDistrictCity')}
                    name='rdc' type='async-select' domain='region-district-city' filterByValuePrefix
                    errors={errors} touched={touched} />}

                <BbInput style={flexStyle} label={this.props.translate("Search.Address.Street")} name="street" type="text" errors={errors} touched={touched} />
            </div>
            <div style={{ display: "none" }}>
                <input type="submit" id="fake-submit"></input>
            </div>
        </Form>);
    }

    createValidationSchema = () => {
        const pinBdTest = /(^$)|(^\s*(\d\d)(\d\d)(\d\d)[\/]*(\d\d\d)(\d?)\s*$)|(^([0-9]|[0-2][0-9]|(3)[0-1])(\.|\/|-)([0-9]|((0)[0-9])|((1)[0-2]))(\.|\/|-)\d{4}$)/i;

        return (
            Yup.object().shape({
                'birthDate': Yup.string()
                    .matches(pinBdTest, { message: this.props.translate("Search.Common.Validation.WrongInput") })
            })
        )
    }

    createInitialValues = () => {
        const em = this.createEmptyValues();
        const sp = this.props.searchParams || {};
        if (this.state.reset) {
            return {
                name: em.name,
                bankAccount: em.bankAccount,
                street: em.street,
                rdc: em.rdc,
                isPo: this.props.isPo
            }
        } else {
            return {
                name: sp.name || em.name,
                bankAccount: sp.bankAccount || em.bankAccount,
                street: sp.street || em.street,
                rdc: this.parseRdc() || em.rdc,
                isPo: this.props.isPo
            };
        }
    }

    createEmptyValues = () => {
        return {
            name: '',
            bankAccount: '',
            street: '',
            rdc: [],
            isPo: true
        };
    }

    submitNew = (values) => {
        const fd = this.getBasicSearchFormData(values);

        const domainLabels = this.getSelectedDomains(values);
        this.props.setSearchDomain(domainLabels);
        //dont perform search yet, just push to qs, search results component will send the actual request
        this.props.redirect(`${this.props.match.url}/results?${this.createQueryString(fd)}`);
    }

    createQueryString = (fd) => {
        //search type and entity type always filled
        let qs = `type=${encodeURIComponent(searchType.BS)}`;
        qs += `&isPo=${encodeURIComponent(fd.isPo)}`;
        //optional params
        if (!isNullOrUndefined(this.state.query) && this.state.query !== "") qs += `&q=${encodeURIComponent(this.state.query)}`;
        if (!isNullOrUndefined(fd.bankAccount) && fd.bankAccount !== "") qs += `&bankAccount=${encodeURIComponent(fd.bankAccount)}`;
        if (!isNullOrUndefined(fd.dob) && fd.dob !== "") qs += `&dob=${encodeURIComponent(fd.dob)}`;
        if (!isNullOrUndefined(fd.rdcIds) && fd.rdcIds.length > 0) {
            qs += `&rdcIds=${fd.rdcIds.join(",")}`;
        }
        if (!isNullOrUndefined(fd.street) && fd.street !== "") qs += `&street=${encodeURIComponent(fd.street)}`;

        return qs;
    }

    getSelectedDomains = (values) => {
        let rdc = {};
        values.rdc.forEach(x => rdc[x.value] = x.label);
        return {
            'rdcIds': rdc
        }
    }

    getBasicSearchFormData = (values) => {
        return {
            "name": this.getString(values.name),
            "dob": this.state.dob,
            "street": this.getString(values.street),
            "rdcIds": values.rdc.filter(x => x.value !== "").map(x => x.value),
            "isPo": this.props.isPo,
            "bankAccount": values.bankAccount
        }
    }

    getString = (s) => isNullOrUndefined(s) || s.trim() === "" ? null : s.trim().replace(/\s+/gi, " ");

    onInputChanged = (event, force = false) => {
        if (!force) {
            if (isNullOrUndefined(event) || isNullOrUndefined(event.target) || isNullOrUndefined(event.target.value)) {
                this.props.hideQuickSearchResults('mainSearch');
                this.setState({ query: '', qsResult: null, stamp: this.state.stamp + 1 });
                return;
            }

            const keyCode = event.keyCode.toString();
            if (Object.keys(this.opKetCodes).indexOf(keyCode) !== -1) {
                if (!this.opKetCodes[keyCode]())
                    if (keyCode !== "32")
                        return;
                    else if ((event.target || {}).selectionEnd === ((event.target || {}).value || {}).length)   //skip space only in the end
                        return;
            }
        }

        const term = force ? this.state.query : (((event || {}).target || {}).value || { trim: function () { return undefined } }).trim();
        if ((this.state.lastValidDob == null || this.state.lastValidDob.length === 4) && (term === null || term === undefined || term.length <= 2)) {
            this.props.hideQuickSearchResults('mainSearch');
            this.setState({ qsResult: null, query: term, stamp: this.state.stamp + 1 });
        }
        else if ((this.state.lastValidDob != null && this.state.lastValidDob.length !== 4 && (term === undefined || term === '')) || (term !== null && term !== undefined && term.length >= 3)) {
            let runSearch = false;
            let dobToRun = '';
            if (term === this.state.query) {
                if (this.state.lastValidDob !== null && this.state.lastValidDob !== undefined && this.state.lastValidDob === this.state.dob) {
                    runSearch = true;
                    dobToRun = this.props.isPo ? '' : this.state.lastValidDob;
                }
            } else if (this.state.lastValidDob !== this.state.dob) {
                this.dobInputRef.value = '';
                runSearch = true;
            } else {
                runSearch = true;
                dobToRun = this.props.isPo ? '' : this.state.lastValidDob;
            }

            if (runSearch) {
                const newStamp = this.state.stamp + 1;
                this.props.showQuickSearchResults('mainSearch');
                this.setState({ validLength: true, query: term, stamp: newStamp });
                this.loadQs(term, dobToRun, newStamp);
            }
        } else {
            this.setState({ validLength: false, query: term });
        }
    }

    onSearchSubmit = (event) => {
        if (event.key !== 'Enter' || isNullOrUndefined(event) || isNullOrUndefined(event.target) || isNullOrUndefined(event.target.value)) {
            return;
        }
        ((!isNullOrUndefined(this.state.query) && this.state.query.length > 2) || (!isNullOrUndefined(this.state.lastValidDob) && this.state.validDob)) && document.querySelector("[type=submit]").click();
    }

    loadQs = (query, dob, stamp) => {
        this.setState({ isSearching: true });
        if (this.state.pendingReq !== undefined) {
            clearTimeout(this.state.pendingReq);
        }
        this.setState({
            pendingReq: setTimeout(function () {
                apiGet.call(this, `${getHostApi()}/api/search/quick`, { query, stamp, type: this.props.isPo ? 1 : 2, dob: dob },
                    res => {
                        if (res.data.stamp === this.state.stamp && (this.props.isPo ? 1 : 2) === res.data.searchType) {
                            this.setState({ qsResult: res.data });
                            this.props.syncFromSearch(res.data.subjects);
                        }
                    },
                    err => { },
                    alw => this.setState({ isSearching: false }))
            }.bind(this), 125)
        });
    }

    domainsLoading = () => {
        return this.props.domain['region-district-city'].isRequesting || this.props.domain['region-district-city'].requestResult == null;
    }

    parseRdc = () => {
        //wait for rdc to load then parse from query string and put to store
        if (!this.domainsLoading() && this.props.searchDomains !== null) {
            let rdc = [];
            Object.keys(this.props.searchDomains.rdcIds).map(s => {
                let found = this.props.domain['region-district-city'].requestResult.find(x => x.value === s);
                rdc.push(found);
            })
            return rdc;
        }
        return [];

    }

    onFocus = () => {
        !this.props.quickSearchResults.mainSearch && this.props.showQuickSearchResults('mainSearch');
    }

    geVIESLinkLocale() {
        switch (getLanguage()) {
            case 'sk-SK': return "sk";
            case 'cs-CZ': return "cs";
            case 'en-US': return "en";
            case 'de-DE': return "de";
            default: return 'sk';
        }
    }

    renderLinks = () => {

        const euLinks = [
            { label: "VIES", link: "https://ec.europa.eu/taxation_customs/vies/?locale=" + this.geVIESLinkLocale(), title: this.props.translate('Links.Site.VIES.Title') },
        ];

        const czLinks = [{ label: "ARES", link: "https://ares.gov.cz/ekonomicke-subjekty" },
        { label: "Sbírka listin", link: "https://or.justice.cz/ias/ui/rejstrik" },
        { label: "RŽP", link: "https://www.rzp.cz/verejne-udaje/cs/udaje/vyber-subjektu" },
        { label: "Insolvenční rejstřík", link: "https://isir.justice.cz/isir/common/index.do" },
        { label: "ČSÚ", link: "https://apl.czso.cz/res/search" },
        { label: "Registr smluv", link: "https://smlouvy.gov.cz/" },
        { label: "Registr plátců DPH", link: "https://adisreg.mfcr.cz/adistc/DphReg?ZPRAC=FDPHI1&poc_dic=1" },
        { label: this.props.translate('Links.Site.ESM'), link: "https://esm.justice.cz/ias/issm/rejstrik", title: this.props.translate('Links.Site.ESM.Title') }
        ];
        const skLinks = [{ label: "Obchodný register", link: "http://www.orsr.sk/search_subjekt.asp" },
        { label: "Živnostenský register", link: "https://www.zrsr.sk/" },
        { label: this.props.translate('Links.Site.RPVS'), link: "https://rpvs.gov.sk/rpvs/", title: this.props.translate('Links.Site.RPVS.Title') },
        { label: "RÚZ", link: "http://www.registeruz.sk/cruz-public/domain/accountingentity/simplesearch" },
        //{label:"Obchodný vestník", link: "https://www.justice.gov.sk/PortalApp/ObchodnyVestnik/Web/Zoznam.aspx" },
        { label: "Štatistický úřad", link: "https://slovak.statistics.sk/wps/portal/ext/Databases/register_organizacii/!ut/p/z1/jZFNb4JAEIZ_Sw9cnaGg0N7Wtq4YYl0sH51LsxLUTRfXApb035eoV5G5TeZ93vkCggzoIH_VTjbKHKTu8k-afDEhxDpMEuTJ4wwDx-a4jGPEmQfpWSC8wJ9ObYb-MnrD4IOteLRwbXTHQF35hbO564WIfsjHGLB5HD0Jx3l_da98j4CG9L_BI3OG8XgjGA7jewTUb58C9Z3ovME9D7o35AJop83m8s990xyfLbSwbduR2pSj3JQWatOcagvrQlb5HujnVFR_kOWV2g5mtMmlLiCrv-FYxl1kqFZl6tfs4R9qUdJb/dz/d5/L2dJQSEvUUt3QS80TmxFL1o2X1ZMUDhCQjFBMDgxVjcwSUZTUTRRVU0xR1E1/" },
        { label: "Register smluv", link: "https://www.crz.gov.sk/" },
        { label: "Informačné zoznamy Finančnej správy SR", link: "https://www.financnasprava.sk/sk/elektronicke-sluzby/verejne-sluzby/zoznamy/" }
        ];

        return (
            <div className={classnames("qs-links search")}>
                {euLinks.length > 0 && <>
                    <span className={classnames("qs-links-label")}><Translate id="Report.Quick.Link.EUSources" />:&nbsp;</span>
                    <div >{euLinks.map(l => this.renderLink(l))}</div>
                </>}
                {czLinks.length > 0 && <>
                    <span className={classnames("qs-links-label")}><Translate id="Report.Quick.Link.CZSources" />:&nbsp;</span>
                    <div >{czLinks.map(l => this.renderLink(l))}</div>
                </>}
                {skLinks.length > 0 && <>
                    <span className={classnames("qs-links-label")}><Translate id="Report.Quick.Link.SKSources" />:&nbsp;</span>
                    <div>{skLinks.map(l => this.renderLink(l))}</div>
                </>}
            </div>
        )
    }

    renderLink = (link) => (
        <SanitizedLink
            key={link.label}
            link={link.link}
            title={link.title}
            label={link.label}
        />
    )

    getSearchTipsModel = () => {
        switch (this.props.isPo) {
            case false:
                return { title: `${this.props.translate('Search.Common.PhysicalPerson')}`, bodyHtml: this.props.translate('SearchTips.Search.FO.Body') };
            case true:
                return { title: `${this.props.translate('Search.Common.Company')}`, bodyHtml: this.props.translate('SearchTips.Search.PO.Body') };
            default:
                return undefined;
        }
    }
}

export default withRouter(withLocalize(connect(
    state => { return { ...state.search, layout: state.layout, domain: state.domain, ls: state.lastSubjects, user: state.userContext } },
    dispatch => bindActionCreators(Object.assign({}, searchActions, layoutActions, entityIdentRowActions, domainActions, lastSubjectActions, windowActions), dispatch),
)(SearchComponent)));